import type { CommentablePersonProfile, SSOIdPConfig, User } from 'js/src/client';
import type { DeepReadonly } from 'js/src/libs/consts';

export type SSOIdPConfigKey = keyof SSOIdPConfig;

export enum ACCOUNT_ACTIONS {
    // workspaces
    STORE_WORKSPACES = 'STORE_WORKSPACES',
    UPDATE_WORKSPACE = 'UPDATE_WORKSPACE',
    // workspace members
    STORE_WORKSPACE_MEMBERS = 'STORE_WORKSPACE_MEMBERS',
    // team members
    STORE_TEAM_MEMBERS = 'STORE_TEAM_MEMBERS',
    UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER',
    // user
    STORE_USER = 'STORE_USER',
    // projects
    STORE_PROJECTS = 'STORE_PROJECTS',
    SET_PROJECTS_LOADING_INDICATOR = 'SET_PROJECTS_LOADING_INDICATOR',
    DELETE_PROJECT = 'DELETE_PROJECT',
    // team settings
    STORE_TEAM_SETTINGS = 'STORE_TEAM_SETTINGS',
    UPDATE_MAX_TEAM_SIZE = 'UPDATE_MAX_TEAM_SIZE',
    // invitations
    SET_INVITATIONS_LOADING = 'SET_INVITATIONS_LOADING',
    STORE_INVITATIONS = 'STORE_INVITATIONS',
    DELETE_INVITATION = 'DELETE_INVITATION',
    CREATE_INVITATIONS = 'CREATE_INVITATIONS',
}

export const DamAuthPopupBroadcastChannelName = 'dam-auth-popup-channel';
export enum DamBroadcastMessageType {
    REFRESH = 'refresh',
}
export type DamBroadcaseMessage = {
    type: DamBroadcastMessageType;
    // `error` reflects whether the OAuth connect flow failed. Consumers that reload on REFRESH can
    // ignore it; consumers that optimistically update UI must only treat `error === false` as success.
    data: { error: boolean } | null;
};

export function isDamBroadcaseMessage(msg: unknown): msg is DamBroadcaseMessage {
    return (
        typeof msg === 'object' &&
        msg !== null &&
        'type' in msg &&
        typeof msg.type === 'string' &&
        Object.values(DamBroadcastMessageType).includes(msg.type as DamBroadcastMessageType)
    );
}

export type SocialCompleteResponse = {
    next?: string;
    invited?: string | number;
    is_signup?: string | number;
    mfa_partial_token?: string;
};

export type SocialCompletePayload = {
    one_time_password?: string;
    partial_token: string;
    recovery_codes_shown?: boolean;
    is_signup?: string;
    continue_with_signup?: string;
};

export function convertUserToCommentablePersonProfile(
    user: DeepReadonly<User>,
): CommentablePersonProfile {
    return {
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
    };
}
